export default __webpack_public_path__ + "static/media/profileSidebarIcon_ranking.bb7d4cc0.svg";